module.exports = __webpack_public_path__ + "static/media/bg-photo-1.8c0be173.png";